import { render } from "./ThemesEdit.vue.js?vue&type=template&id=7d5d3bfd!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesEdit.vue?vue&type=template&id=7d5d3bfd"
import script from "./ThemesEdit.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesEdit.vue?vue&type=script&lang=js"
export * from "./ThemesEdit.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ThemesEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d5d3bfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d5d3bfd', __exports__)) {
    api.reload('7d5d3bfd', __exports__)
  }
  
  module.hot.accept("./ThemesEdit.vue.js?vue&type=template&id=7d5d3bfd!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesEdit.vue?vue&type=template&id=7d5d3bfd", () => {
    api.rerender('7d5d3bfd', render)
  })

}


export default __exports__